import React, { ReactElement } from 'react';
import { ItemTitleContainerProps } from './itemTitle.model';
import { ItemTitleContainerStyled } from './itemTitle.styled';

export const ItemTitleContainer = ({
  title,
}: ItemTitleContainerProps): ReactElement => (
  <ItemTitleContainerStyled>{title}</ItemTitleContainerStyled>
);
